import {insertFeaturedGrants} from "./inserters/insertFeaturedGrants";
import {insertFeaturedProjects} from "./inserters/insertFeaturedProjects";
import {insertForumThread} from "./inserters/insertForumThread";
import {insertLargeGrantApplication} from "./inserters/insertLargeGrantApplication";
import {insertLargeGrantAwardees} from "./inserters/insertLargeGrantAwardees";
import {insertMembers} from "./inserters/insertMembers";
import {insertMiniGrantApplication} from "./inserters/insertMiniGrantApplication";
import {insertMiniGrantAwardees} from "./inserters/insertMiniGrantAwardees";
import {insertPressReleases} from "./inserters/insertPressReleases";
import {insertPublications} from "./inserters/insertPublications";
import {insertQSpaceFeaturedContent} from "./inserters/insertQSpaceFeaturedContent";
import {insertReports} from "./inserters/insertReports";

window.addEventListener('DOMContentLoaded', () => {
  insertFeaturedGrants();
  insertFeaturedProjects();
  insertForumThread();
  insertLargeGrantApplication();
  insertLargeGrantAwardees();
  insertMembers();
  insertMiniGrantApplication();
  insertMiniGrantAwardees();
  insertPressReleases();
  insertPublications();
  insertQSpaceFeaturedContent();
  insertReports();
});
